import React from 'react';

export interface SidebarFlyoutState {
  openKey?: string;
  open: (key: string) => void;
  closeSoon: () => void;
  close: () => void;
}

export const SidebarFlyoutContext = React.createContext<SidebarFlyoutState>({
  open: () => { },
  closeSoon: () => { },
  close: () => { },
});
